import { html } from '@shared/utils/rendering/html';

import { Icon } from '@shared/components/icons';

import { ERMPortalUrls } from '../../constants/routing/urls.constants';
import { Systems } from '../../constants/security/systems.constants';

import { IncludeSystem } from './system-utils.config';

export const GenerateSidebarConfig = (user, options = {}) => {
    const { featureCheck, ...sidebarOptions } = options;

    return {
        collapse: true,
        alwaysShowLabels: false,
        ...sidebarOptions,
        navigation: GenerateSidebarOptions(user, featureCheck),
    };
};

const GenerateSidebarOptions = (user, featureCheck) => {
    const options = [];

    IncludeSystem(Systems.EWIS, user, featureCheck) &&
        options.push({
            icon: html`<${Icon} name=${'crisis_alert'} />`,
            text: 'EWIS',
            href: ERMPortalUrls.ewis,
        });

    IncludeSystem(Systems.RiskAppetite, user, featureCheck) &&
        options.push({
            icon: html`<${Icon} name=${'query_stats'} />`,
            text: 'Risk Appetite',
            href: ERMPortalUrls.riskAppetite,
        });

    IncludeSystem(Systems.RDARR, user, featureCheck) &&
        options.push({
            icon: html`<${Icon} name=${'finance'} />`,
            text: 'RDARR',
            href: ERMPortalUrls.rdarr,
        });

    IncludeSystem(Systems.RiskCulture, user, featureCheck) &&
        options.push({
            icon: html`<${Icon} name=${'psychology'} />`,
            text: 'Risk Culture',
            href: ERMPortalUrls.riskCulture,
        });

    IncludeSystem(Systems.Indicators, user, featureCheck) &&
        options.push({
            icon: html`<${Icon} name=${'finance_mode'} />`,
            text: 'Indicators',
            href: ERMPortalUrls.indicatorMicroservice,
        });

    return options;
};
